export const priceSpTable = () => {
  function openTab(event, tabId) {
    // タブコンテンツを全て非表示にする
    const tabContents = document.querySelectorAll(".price-sp-table__tab-content");
    tabContents.forEach((content) => {
      content.style.display = "none";
    });

    // 全てのタブボタンから 'active' クラスを削除する
    const tabButtons = document.querySelectorAll(".price-sp-table__tab-button");
    tabButtons.forEach((button) => {
      button.classList.remove("price-sp-table__tab-button--active");
    });

    // 指定されたタブコンテンツを表示し、クリックされたタブボタンに 'active' クラスを追加する
    const targetTab = document.getElementById(tabId);
    if (targetTab) {
      targetTab.style.display = "block";
      event.currentTarget.classList.add("price-sp-table__tab-button--active");
    } else {
      console.error(`Tab content with id '${tabId}' not found.`); // エラーログ
    }
  }

  // イベントリスナーをタブボタンに追加
  const tabButtons = document.querySelectorAll(".price-sp-table__tab-button");
  if (tabButtons.length === 0) {
    console.error("No tab buttons found."); // エラーログ
    return;
  }

  tabButtons.forEach((button) => {
    button.addEventListener("click", (event) => {
      const tabId = button.getAttribute("data-tab");
      openTab(event, tabId);
    });
  });

  // デフォルトで2番目のタブを表示する
  if (tabButtons[1]) {
    tabButtons[1].click();
  } else {
    console.error("Default second tab button not found."); // エラーログ
  }
};
